import { ErrorMessage, Field, Form, Formik } from "formik";
import { object, string } from "yup";
import {
  // submitQuestion,
  updatedSubmitQuestion
} from "@/services/product";
import { getCookies } from "cookies-next";
import toast from "react-hot-toast";
import Accordion from "./Accordion";
import store from "store";
import { getSession, useSession } from "next-auth/react";
import { useContext, useEffect, useRef } from "react";
import { ModalContext } from "@/pages/_app";

const Q_A = ({ parentProduct, faqs, t }) => {
  const { handshake } = getCookies();
  const questionValidationSchema = () =>
    object({
      question: string().required(t("Question can't be empty")),
    });
  const { data: session } = useSession()
  const Context = useContext(ModalContext);
  const AddNewQuestionRef = useRef(null);

  const productFaqQuestion = store.get("productFaqQuestion")
  
  useEffect(() => {
    // store.remove("productFaqQuestion")
    const handleAddingQuestion = async () => {
      const getUpdatedSession = await getSession()
      if (!Context?.state.auth && productFaqQuestion && !getUpdatedSession?.user?.id) {
        store.remove("productFaqQuestion")
        return
      }
      !Context?.state.auth && AddNewQuestionRef && AddNewQuestionRef?.current?.click()
    }
    
    Object.keys(session || {})?.length && !Context?.state.auth && productFaqQuestion && handleAddingQuestion()
  }, [productFaqQuestion, Context?.state.auth, session])

  async function handleSubmitQuestion(values) {
    if (session) {
      const res = await updatedSubmitQuestion(
        values?.question,
        Array.isArray(parentProduct?.sku)
          ? parentProduct?.sku?.at(0)
          : parentProduct?.sku,
          session ? session.user.id : "",
        handshake
      );
      if (res.status == 200) {
        toast.success(res?.data?.data?.message);
      } else {
        toast.error(res?.error?.error?.message);
      }
      store.remove('productFaqQuestion')
      return
    }
    store.set("productFaqQuestion", {
      question: values?.question,
      sku: Array.isArray(parentProduct?.sku)
        ? parentProduct?.sku?.at(0)
        : parentProduct?.sku,
    })
    Context?.dispatch({ type: "auth" });
  }

  console.log('faqs/////////', faqs)

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-full lg:col-span-9">
        {faqs?.length > 0 ? (
          <div className="flex items-center justify-between mb-4 overflow-x-auto overflow-y-hidden gap-7">
            <div className="flex items-center gap-7">
              {/* <p className="text-xs font-bold whitespace-nowrap sm:text-lg">
              Apple Airpods
            </p> */}
              {/* <p className="text-xs sm:text-lg whitespace-nowrap">
                {faqs?.length} {t("Questions")}
              </p> */}
            </div>
            {/* <p className="text-xs sm:text-[15px] whitespace-nowrap text-[#959494]">
              {t("Most Common Questions")}
            </p> */}
          </div>
        ) : (
          <div className="flex items-center justify-center min-h-44 text-slate-400 sm:text-xl">
            {t("There are no questions for this product yet")}
          </div>
        )}
        {/* <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <ArrowIcon className="size-2.5 sm:size-4" />
            <span className="text-sm font-bold max-sm:w-3/4 sm:text-lg">
              Is the original FTZ adapter compatible with the Z8 or is the FTZ
              II required?
            </span>
          </div>
          <p className="text-xs sm:text-[15px] text-[#959494] whitespace-nowrap">
            4 ANSWERS
          </p>
        </div> */}
        {/* <button className="border border-[#744A92] w-36 rounded-md text-[#744A92] p-1 sm:p-2 text-xs sm:text-[15px]">
          Add Answer
        </button> */}
        <section className="my-4 flex flex-col gap-1">
          {faqs.map((faq, i) => (
            <Accordion key={i} {...{ Context, head: faq?.q, body: faq?.a, fromPDP: true, questionId: faq?.q_id, sku: Array.isArray(parentProduct?.sku)
              ? parentProduct?.sku?.at(0)
              : parentProduct?.sku, }} />
          ))}
        </section>
      </div>
      <div className="col-span-full lg:col-span-3 h-fit bg-[#F8F7F7] p-3">
        <h4 className="text-sm sm:text-lg mb-3 text-[#744A91] font-bold">
          {t("Ask Question")}
        </h4>
        <Formik
          initialValues={{ question: "" }}
          validationSchema={questionValidationSchema}
          onSubmit={handleSubmitQuestion}
        >
          {({ isSubmitting }) => (
            <Form>
              <Field
                as="textarea"
                className="block w-full p-2 bg-white rounded-sm resize-none sm:p-4"
                rows="5"
                name="question"
              />
              <ErrorMessage
                component="p"
                name="question"
                className="text-red-500"
              />
              <p className="text-[13px] sm:text-sm text-[#959494] text-center my-2">
                {t("Can't find what you're looking for?")}
              </p>
              <button
                ref={AddNewQuestionRef}
                type="submit"
                disabled={isSubmitting}
                className="flex justify-center items-center gap-2 w-11/12 text-sm sm:text-[15px] p-1 mx-auto text-white rounded-md bg-primary"
              >
                {isSubmitting && <div className="loader w-6 text-white" />}
                <p>{t("Submit a New Question")}</p>
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Q_A;
